import { render, staticRenderFns } from "./news_view_mobile.vue?vue&type=template&id=096059ac&scoped=true&"
import script from "./news_view_mobile.vue?vue&type=script&lang=js&"
export * from "./news_view_mobile.vue?vue&type=script&lang=js&"
import style0 from "./news_view_mobile.vue?vue&type=style&index=0&id=096059ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096059ac",
  null
  
)

export default component.exports